import React, { Component } from "react"
import SpotLightSider from "./Spot-Light-Slider"
import "./index.css"

class HomeSpotLightSection extends Component {
  render() {
    return (
      <section id="home-spot-light-section">
        <div className="container">
          <div className="row">
            <div className="col-12 home-spot-light-text text-center mt-auto">
              <img
                className="img-fluid"
                src={require("../../../images/Icons/spot-light-head.png")}
              />
              <h2>IMMER MONTAGS & DIENSTAGS</h2>
              <p>
                <strong>
                  Ob Jazz, Pop, Rock, Soul, Literatur, Kabarett, Tribute-Show
                  oder Performance –
                </strong>
                <br />
                es gibt immer etwas Neues im Spotlight-Programm zu entdecken.
              </p>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col">
              <SpotLightSider />
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-12 text-center mt-auto">
              <button className="btn die-show-btn">DIE SHOW</button>
              <button className="btn tickets-btn">TICKETS</button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default HomeSpotLightSection
